/**
 * Timer Component
 * Displays countdown timer
 */

interface TimerProps {
  timeRemaining: number
  isRunning: boolean
  hasTimer: boolean
}

export default function Timer({ timeRemaining, isRunning, hasTimer }: TimerProps) {
  if (!hasTimer) {
    return null
  }

  return (
    <div className={`flashcard__timer ${isRunning ? 'flashcard__timer--running' : ''}`}>
      <span className="flashcard__timer-icon">⏱️</span>
      <span className="flashcard__timer-value">{timeRemaining}s</span>
    </div>
  )
}
